var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff1E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 55.63 172.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#916657;}.cls-2{fill:#232323;}.cls-3{fill:#0e5279;}.cls-4{fill:#004568;}.cls-5{fill:#1199a1;}.cls-6{fill:#14adb2;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Female_02b",
    "data-name": "Staff_Female_02b",
    viewBox: "0 0 55.63 172.54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.58,72.29,3.26,76.75s-3.53,4.41-3,4.89S4,80.07,4,80.07l-4,5.5a4.84,4.84,0,0,0,1.81,2.12c1.16.59,7-2.13,8.27-3.92s3.86-10,3.86-10l4.27-6.91-7.41-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.11,159.06s1.5,2.66,1.33,4.16-4.47,4.68-8.31,7c-4.16,2.5-8.48,3-10.48,1.5s5.66-8,9-10.81S42.11,159.06,42.11,159.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.12,152.9s1,2.9.53,4.34-4.41,2.62-8.48,4.48-9.29,3.51-11,1.67,6.82-7.32,10.25-10.27S24.12,152.9,24.12,152.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.44,116.83c-.67,16.63-1.5,38.58-1.5,42.4s-12.47,6.82-12.64.17-1-38.91-1-38.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13,115.52s.22,34.77.49,37.25c.34,3,10.48,2.82,10.48-1.33,0-6.32,3.16-36.92,3.16-36.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.09,27.32c-3.32.28-4.87,1.73-6.23,9.92s-1.8,14.34-2.23,16.7S7.85,69.17,7,72.05c-.93,3.3,5.66,6.1,8.28,2.41S24.7,57.9,25.64,55.54C26.68,52.92,32.52,26.52,23.09,27.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.8,28.21c7.57,1.24,13.3,6.15,13.8,11.8s-1.83,26.61-1.83,31.43,2.82,11.31,3,20.45.33,21,.33,27.77c-9.64,5.49-16.29,5.65-21.45,5.32s-16.46-3.66-16.46-3.66c-.16-17.29,3.49-37.08,4-45.06S17.67,60.47,17,58s-3.32-4.15-3-7.31,4.16-13.31,6.15-18S25.65,26.71,34.8,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.83,10.42c-1.34,4.76-1.67,13.13-1,15.46s3.49,3.16,6.48,3.33c.34,3,1.33,10,1.33,10,6-3,10-10.14,10-10.14l-.5-4c4-.83,8-5,8.48-11.8S42.44,2.11,35.46,1.77,23.32,5.1,21.83,10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.54,85.25s-5,3.09-6.15,4.7-2.12,2.83-2.89,4,0,2.38,1.78,1.15,2.65-1.92,2.65-1.92-2.23,5.17-2.7,6.52c-.63,1.83,1,2.18,2.86,2.29s5.56-4.24,6.39-5.94,3.93-10.35,3.93-10.35L49,81.08l-5.7-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.36,35c3.35-1.85,7.11,3.08,8.66,11.25S56,61.93,55.53,67s-2.15,8.28-3.78,11.85a56.49,56.49,0,0,1-5,9.38c-1.65,2.34-8.75-.36-7.16-4.09s6.12-16.08,5.5-19S35.83,39.68,44.36,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.69,4.67A6.75,6.75,0,0,0,42.18.38a5.85,5.85,0,0,0-1.57.87C33.07-1.55,21.66,1,20,9.42,18.9,15,30.31,14.91,30.31,14.91a14.6,14.6,0,0,0,2.32,4.49c.83-2.83,5.82-3.16,6.16-.17s-1.5,4.66-2.83,5,1.5,2.83,1.5,2.83,8.31-.34,10.3-9.81a22.58,22.58,0,0,0,.53-4.41A6.9,6.9,0,0,0,50.69,4.67Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion_-_Handlinger",
    "data-name": "Fyldning & Inspektion - Handlinger"
  }, /*#__PURE__*/React.createElement("use", {
    width: 55.63,
    height: 172.54,
    transform: "matrix(-1, 0, 0, 1, 55.63, 0)",
    xlinkHref: "#Staff_Female_02b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff1E);
export default __webpack_public_path__ + "static/media/staff-1-e.9260ef1037f13e775472266105037d61.svg";
export { ForwardRef as ReactComponent };